import Component from "./ButtonCircle";
import Counter from "./components/Counter/ButtonCircleCounter";
import Icon from "./components/Icon/ButtonCircleIcon";
import Label from "./components/Label/ButtonCircleLabel";
import Loader from "./components/Loader/ButtonCircleLoader";

interface IButtonCircleExtensions {
    Counter: typeof Counter;
    Icon: typeof Icon;
    Loader: typeof Loader;
    Label: typeof Label;
}

export const ButtonCircle: typeof Component & IButtonCircleExtensions =
    Object.assign(Component, {
        Counter,
        Icon,
        Loader,
        Label,
    });

export * from "./ButtonCircle";
export type { ButtonCircleProps } from "./types";
export * from "./presets";
